const AppRouter = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/Views/HomePage.vue")
    },
    {
        path: "/About",
        name: "About",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/AboutUs.vue")
    },
    {
        path: "/Services",
        name: "Services",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/ServicePage.vue")
    }, 
    {
        path: "/TechStack",
        name: "TechStack",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/TechStack.vue")
    },
    {
        path: "/PortFolio",
        name: "PortFolio",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/PortFolio.vue")
    },
    {
        path: "/ContactUs",
        name: "ContactUs",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/ContactUs.vue")
    }             
]

export default AppRouter;